import { resolveKbUrlImportDefaultMaxPages } from "@/lib/ai/knowledge-base/url-import/constants"

export type UrlImportFormValues = {
  url: string
  category: string
  tags: string
  injectionMode: "auto" | "direct" | "rag"
  isDefault: boolean
  maxPages: number
  maxDepth: number
}

export function getUrlImportDialogInitialValues(
  maxPagesLimit: number,
  folder?: {
    source_url: string | null
    metadata: Record<string, unknown>
  } | null,
): UrlImportFormValues {
  const importConfig = toRecord(folder?.metadata.import_config)
  const configuredMaxPages = typeof importConfig.maxPages === "number"
    ? importConfig.maxPages
    : resolveKbUrlImportDefaultMaxPages(maxPagesLimit)

  return {
    url: folder?.source_url ?? "",
    category: typeof importConfig.category === "string" ? importConfig.category : "",
    tags: Array.isArray(importConfig.tags)
      ? importConfig.tags.filter((tag): tag is string => typeof tag === "string").join(", ")
      : "",
    injectionMode: resolveInjectionMode(importConfig.injectionMode),
    isDefault: typeof importConfig.isDefault === "boolean" ? importConfig.isDefault : true,
    maxPages: Math.max(1, Math.min(configuredMaxPages, Math.max(1, maxPagesLimit))),
    maxDepth: typeof importConfig.maxDepth === "number" ? importConfig.maxDepth : 3,
  }
}

function toRecord(value: unknown): Record<string, unknown> {
  return value && typeof value === "object" && !Array.isArray(value)
    ? value as Record<string, unknown>
    : {}
}

function resolveInjectionMode(value: unknown): UrlImportFormValues["injectionMode"] {
  if (value === "direct" || value === "rag") return value
  return "auto"
}
